// extracted by mini-css-extract-plugin
export default {"conteinerCarrouselMarcas":"NuestrasMarcas_conteinerCarrouselMarcas__QHCJk","swiperSlide":"NuestrasMarcas_swiperSlide__lJ9b7"};